import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { organizationDetailsKeys } from '../../api/query-keys/organization-details';

import { organizationApi } from '@/api/organization-admin/organization';
import { Organization } from '@/types/organization/organization';

export const useOrganizationDetails = () => {
  return useQuery<Organization, ApiError>({
    queryKey: organizationDetailsKeys.list(),
    queryFn: organizationApi.fetchOrganizationDetails,
  });
};
